import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { PrayerProvider } from './contexts/PrayerContext';
import { TrackerProvider } from './contexts/TrackerContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { QazaProvider } from './contexts/QazaContext';
import TopHeader from './components/layout/TopHeader';
import BottomNav from './components/layout/BottomNav';
import Footer from './components/layout/Footer';
import HomePage from './components/pages/HomePage';
import QiblaPage from './components/pages/QiblaPage';
import TrackerPage from './components/pages/TrackerPage';
import SettingsPage from './components/pages/SettingsPage';
import QuranPage from './components/pages/QuranPage';
import SurahReaderPage from './components/pages/SurahReaderPage';
import AuthCallback from './components/pages/AuthCallback';
import AdminPage from './components/pages/AdminPage';
import NotFoundPage from './components/pages/NotFoundPage';
import GlobalQuranBar from './components/quran/GlobalQuranBar';
import { QuranPlayerProvider } from './contexts/QuranPlayerContext';
import { usePrayerNotifications } from './hooks/usePrayerNotifications';
import { usePrayer } from './contexts/PrayerContext';
import { registerQuranSW } from './services/quranSW';

// Register Quran Service Worker on load
registerQuranSW();

const AppContent = () => {
  const location = useLocation();
  const { prayerTimes } = usePrayer();
  usePrayerNotifications(prayerTimes);

  if (location.hash?.includes('session_id=') || location.pathname === '/auth/callback') {
    return <AuthCallback />;
  }

  if (location.pathname === '/admin') {
    return (
      <>
        <TopHeader />
        <div className="pt-14 pb-8">
          <AdminPage />
        </div>
      </>
    );
  }

  return (
    <>
      <TopHeader />
      <div className="pt-14 pb-28">
        <Routes>
          <Route path="/"              element={<HomePage />} />
          <Route path="/qibla"         element={<QiblaPage />} />
          <Route path="/tracker"       element={<TrackerPage />} />
          <Route path="/quran"           element={<QuranPage />} />
          <Route path="/quran/surah/:id" element={<SurahReaderPage />} />
          <Route path="/settings"      element={<SettingsPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/admin"         element={<AdminPage />} />
          <Route path="*"              element={<NotFoundPage />} />
        </Routes>
      </div>
      <BottomNav />
      <Footer />
      {!location.pathname.startsWith('/quran/surah/') && <GlobalQuranBar />}
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ThemeProvider>
            <AuthProvider>
              <PrayerProvider>
                <TrackerProvider>
                  <QazaProvider>
                    <QuranPlayerProvider>
                      <AppContent />
                    </QuranPlayerProvider>
                  </QazaProvider>
                </TrackerProvider>
              </PrayerProvider>
            </AuthProvider>
          </ThemeProvider>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
